



































import { Vue, Component, Prop, Watch } from 'vue-property-decorator';
import { gsap, Expo } from 'gsap';
import Button from '@/components/Controls/Button/Button.vue';
import Chart from '@/components/Chart/Chart.vue';
import * as events from '@/metrix/events';
import {DecorationSliderStat, DecorationSliderDetail, DecorationSliderProps} from './types';
import SvgIcon from '@/components/SvgIcon';
import { SliderManager } from '@/components/Slider';

@Component({
    components: {
        Button,
        Chart,
        SvgIcon,
        SliderManager
    },
})
export default class DecorationSlider extends Vue implements DecorationSliderProps {
    /**
     *
     */
    @Prop()
    public readonly decorationSliderStat!: DecorationSliderStat;
    /**
     *
     */
    @Prop()
    public decorationSliderDetail!: DecorationSliderDetail;
    /**
     *
     */
    public decorationSliderActual: {} = {};
    /**
     *
     */
    public ind: number = 0;
    /**
     *
     */
    public onFilterDecorationSlider(indexes: number|boolean) {
        let index = indexes ? indexes : 0;
        let morg = (<any>this.decorationSliderStat);
        this.decorationSliderActual = morg[index as number] as DecorationSliderDetail;
        this.ind = index as number;

    }
    /**
     *
     */
    public created() {
        this.onFilterDecorationSlider(false);
    }
}

